<template>
    <div class="production-task">
        <!-- 搜索与筛选区 -->
        <el-card class="search-card">
            <el-form :inline="true" :model="searchForm" class="search-form">
                <el-form-item label="任务编号">
                    <el-input v-model="searchForm.taskNumber" placeholder="输入任务编号" clearable></el-input>
                </el-form-item>
                <el-form-item label="任务名称">
                    <el-input v-model="searchForm.taskName" placeholder="输入任务名称" clearable></el-input>
                </el-form-item>

                <el-form-item label="功能间">
                    <el-select v-model="searchForm.workshopId" placeholder="选择功能间" clearable>
                        <el-option v-for="workshop in productionWorkshops" :key="workshop.id" :label="workshop.roomName"
                            :value="workshop.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="任务状态">
                    <el-select v-model="searchForm.status" placeholder="选择任务状态" clearable>
                        <el-option label="未开始" value="0"></el-option>
                        <el-option label="进行中" value="1"></el-option>
                        <el-option label="已结束" value="2"></el-option>
                        <el-option label="已驳回" value="rejected"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
                    <el-button @click="resetSearch" icon="el-icon-refresh">重置</el-button>
                    <el-button type="primary" @click="showAddTaskDialog" icon="el-icon-plus">创建生产任务</el-button>
                    <!-- <el-button type="warning" @click="exportTaskList" icon="el-icon-download">导出任务清单</el-button> -->
                    <el-button type="success" @click="openBatchAssignDialog" icon="el-icon-s-tools"
                        :disabled="selectedTasks.length === 0">批量分配</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 生产任务列表 -->
        <el-card class="task-list-card">
            <el-table :data="pagedTasks" border stripe @selection-change="handleSelectionChange"
                @row-dblclick="viewTaskDetail" :header-cell-style="{ background: '#f5f7fa', fontWeight: 'bold' }"
                height="60vh" v-loading="loading" element-loading-text="正在加载任务数据...">
                <!-- 多选列 -->
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                <el-table-column prop="taskName" label="任务名称" width="140" align="center"></el-table-column>
                <el-table-column prop="taskNumber" label="任务编号" width="150" align="center"></el-table-column>

                <el-table-column prop="taskStatus" label="任务状态" width="100" align="center">
                    <template #default="scope">
                        <el-tag :type="getStatusType(scope.row.taskStatus)">
                            {{ formatStatus(scope.row.taskStatus) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="room" label="功能间" width="100" align="center"></el-table-column>
                <el-table-column prop="progress" label="任务进度" width="120">
                    <template #default="scope">
                        <el-progress :percentage="scope.row.progress || 0" size="small"></el-progress>
                    </template>
                </el-table-column>
                <el-table-column prop="orderNo" label="订单号" width="160" align="center"></el-table-column>

                <el-table-column prop="productionTime" label="生产时间" width="140" align="center"></el-table-column>
                <el-table-column prop="requiredQuantity" label="需求数量" align="center"></el-table-column>
                <el-table-column prop="unit" label="单位" align="center"></el-table-column>
                <el-table-column prop="actualFeedingQuantity" label="实际投料数量" align="center"></el-table-column>
                <el-table-column prop="actualOutputQuantity" label="实际产出数量" align="center"></el-table-column>

                <el-table-column prop="expectedOutputQuantity" label="预计产出数量" align="center"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="140" align="center"></el-table-column>
                <el-table-column prop="startTime" label="开始时间" width="140" align="center"></el-table-column>
                <el-table-column prop="endTime" label="结束时间" width="140" align="center"></el-table-column>
                <el-table-column prop="pickupTime" label="取货时间" width="140" align="center"></el-table-column>

                <el-table-column label="操作" width="160" align="center">
                    <template #default="scope">
                        <el-button size="mini" type="primary" @click="viewTaskDetail(scope.row)">查看</el-button>
                        <el-button size="mini" type="success" @click="assignTask(scope.row)"
                            v-if="['0', 'rejected'].includes(scope.row.taskStatus)">分配</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" :total="totalCount"
                    layout="total, sizes, prev, pager, next, jumper"></el-pagination>
            </div>
        </el-card>

        <!-- 创建/编辑任务弹窗 -->
        <el-dialog :title="isEditMode ? '编辑生产任务' : '创建生产任务'" :visible.sync="taskFormVisible" width="700px"
            :close-on-click-modal="false" :z-index="2000" append-to-body>
            <el-form ref="taskForm" :model="taskForm" :rules="taskFormRules" label-width="120px" class="task-form">
                <el-form-item label="任务名称" prop="taskName">
                    <el-input v-model="taskForm.taskName" placeholder="输入任务名称"></el-input>
                </el-form-item>
                <el-form-item label="任务类型" prop="taskType">
                    <el-select v-model="taskForm.taskType" placeholder="选择任务类型" @change="getProductList">
                        <el-option label="成品菜" value="成品菜"></el-option>
                        <el-option label="半成品" value="半成品"></el-option>
                    </el-select>
                </el-form-item>
                <!-- 产品名称：输入框改为下拉框，动态匹配任务类型 -->
                <el-form-item label="产品名称" prop="productName">
                    <el-select v-model="taskForm.productName" placeholder="选择产品名称">
                        <el-option v-for="(item, index) in productList" :key="index" :label="item.name"
                            :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="功能间" prop="room">
                    <el-select v-model="taskForm.room" placeholder="选择功能间">
                        <el-option v-for="workshop in productionWorkshops" :key="workshop.id" :label="workshop.roomName"
                            :value="workshop.roomName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="需求数量" prop="requiredQuantity">
                    <el-input v-model.number="taskForm.requiredQuantity" placeholder="输入需求数量"></el-input>
                </el-form-item>
                <el-form-item label="单位" prop="unit">
                    <el-input v-model="taskForm.unit" placeholder="输入单位"></el-input>
                </el-form-item>
                <el-form-item label="订单号" prop="orderNo">
                    <el-input v-model="taskForm.orderNo" placeholder="输入订单号"></el-input>
                </el-form-item>
                <el-form-item label="生产时间" prop="productionTime">
                    <el-date-picker v-model="taskForm.productionTime" type="datetime" placeholder="选择任务生产时间"
                        value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
                <el-form-item label="创建时间" prop="createTime">
                    <el-date-picker v-model="taskForm.createTime" type="datetime" placeholder="选择任务创建时间"
                        value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
                <el-form-item label="取货时间" prop="pickupTime">
                    <el-date-picker v-model="taskForm.pickupTime" type="datetime" placeholder="选择取货时间"
                        value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="taskFormVisible = false">取消</el-button>
                <el-button type="primary" @click="saveTask">保存</el-button>
            </div>
        </el-dialog>

        <!-- 单个任务分配弹窗 -->
        <el-dialog title="分配生产任务" :visible.sync="assignDialogVisible" width="600px" :close-on-click-modal="false"
            :z-index="2000" append-to-body>
            <el-form ref="assignForm" :model="assignForm" :rules="assignFormRules" label-width="120px">
                <el-form-item label="任务编号" prop="taskNumber">
                    <el-input v-model="assignForm.taskNumber" readonly disabled></el-input>
                </el-form-item>
                <el-form-item label="产品名称">
                    <el-input v-model="assignForm.productName" readonly disabled></el-input>
                </el-form-item>
                <el-form-item label="功能间" prop="workshopId">
                    <el-select v-model="assignForm.workshopId" placeholder="选择功能间" @change="handleWorkshopChange">
                        <el-option v-for="workshop in productionWorkshops" :key="workshop.id" :label="workshop.roomName"
                            :value="workshop.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备" prop="equipmentId">
                    <el-select v-model="assignForm.equipmentId" placeholder="选择设备" :disabled="!assignForm.workshopId">
                        <el-option v-for="eq in filteredEquipments" :key="eq.deviceSerialnumber" :label="eq.deviceName"
                            :value="eq.deviceSerialnumber"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="assignDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmAssign">确认分配</el-button>
            </div>
        </el-dialog>

        <!-- 批量分配弹窗 -->
        <el-dialog title="批量分配生产任务" :visible.sync="batchAssignDialogVisible" width="600px" :close-on-click-modal="false"
            :z-index="2000" append-to-body>
            <el-form ref="batchAssignForm" :model="batchAssignForm" :rules="batchAssignRules" label-width="120px">
                <el-form-item label="功能间" prop="workshopId">
                    <el-select v-model="batchAssignForm.workshopId" placeholder="选择功能间" @change="handleWorkshopChange">
                        <el-option v-for="workshop in productionWorkshops" :key="workshop.id" :label="workshop.roomName"
                            :value="workshop.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备" prop="equipmentId">
                    <el-select v-model="batchAssignForm.equipmentId" placeholder="选择设备"
                        :disabled="!batchAssignForm.workshopId">
                        <el-option v-for="eq in filteredEquipments" :key="eq.deviceSerialnumber" :label="eq.deviceName"
                            :value="eq.deviceSerialnumber"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="batchAssignDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitBatchAssign">确认批量分配</el-button>
            </div>
        </el-dialog>

        <!-- 任务详情弹窗 -->
        <el-dialog title="生产任务详情" :visible.sync="detailVisible" width="800px" :close-on-click-modal="false"
            :z-index="2000" append-to-body>
            <div v-if="currentTask" class="task-detail">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-descriptions column="1" border>
                            <el-descriptions-item label="任务编号">{{ currentTask.taskNumber }}</el-descriptions-item>
                            <el-descriptions-item label="关联计划">{{ currentTask.planNo || '无' }}</el-descriptions-item>
                            <el-descriptions-item label="产品名称">{{ currentTask.productName }}</el-descriptions-item>
                            <el-descriptions-item label="产品编码">{{ currentTask.productCode || '无'
                            }}</el-descriptions-item>
                            <el-descriptions-item label="产品规格">{{ currentTask.spec || '无' }}</el-descriptions-item>
                            <el-descriptions-item label="任务数量">{{ currentTask.requiredQuantity }} {{ currentTask.unit ||
                                '件'
                            }}</el-descriptions-item>
                            <el-descriptions-item label="功能间">{{ currentTask.room || '未分配' }}</el-descriptions-item>
                            <el-descriptions-item label="设备">{{ currentTask.equipmentName || '未分配'
                            }}</el-descriptions-item>
                        </el-descriptions>
                    </el-col>
                    <el-col :span="12">
                        <el-descriptions column="1" border>
                            <el-descriptions-item label="负责人">{{ currentTask.operatorName || '未指定'
                            }}</el-descriptions-item>
                            <el-descriptions-item label="创建人">{{ currentTask.creatorName || '系统'
                            }}</el-descriptions-item>
                            <el-descriptions-item label="创建时间">{{ currentTask.createTime }}</el-descriptions-item>
                            <el-descriptions-item label="分配时间">{{ currentTask.assignTime || '未分配'
                            }}</el-descriptions-item>
                            <el-descriptions-item label="开始时间">{{ currentTask.startTime || '未开始'
                            }}</el-descriptions-item>
                            <el-descriptions-item label="截止时间">{{ currentTask.endTime || '无' }}</el-descriptions-item>
                            <el-descriptions-item label="完成时间">{{ currentTask.completeTime || '未完成'
                            }}</el-descriptions-item>
                            <el-descriptions-item label="状态">
                                <el-tag :type="getStatusType(currentTask.taskStatus)" size="large">
                                    {{ formatStatus(currentTask.taskStatus) }}
                                </el-tag>
                            </el-descriptions-item>
                        </el-descriptions>
                    </el-col>
                </el-row>

                <div class="detail-section">
                    <h3>任务描述</h3>
                    <div class="detail-content">{{ currentTask.description || '无' }}</div>
                </div>
                <div class="detail-section">
                    <h3>原料要求</h3>
                    <div class="detail-content">{{ currentTask.materialRequirements || '无' }}</div>
                </div>
                <div class="detail-section">
                    <h3>任务记录</h3>
                    <el-timeline>
                        <el-timeline-item v-for="(record, index) in currentTask.taskRecords || []" :key="index"
                            :timestamp="record.time" :status="record.status">
                            <el-card>
                                <div class="timeline-content">
                                    <div class="record-operator">{{ record.operatorName || '系统' }}</div>
                                    <div class="record-action">{{ record.action }}</div>
                                    <div class="record-remark" v-if="record.remark">{{ record.remark }}</div>
                                </div>
                            </el-card>
                        </el-timeline-item>
                        <el-timeline-item v-if="!(currentTask.taskRecords && currentTask.taskRecords.length)"
                            timestamp="无记录" status="info">
                            <el-card>暂无任务操作记录</el-card>
                        </el-timeline-item>
                    </el-timeline>
                </div>
            </div>
            <div slot="footer">
                <el-button @click="detailVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { addProduction, getProductionList, updateProductionStatus } from "@/api/productionManagement";
import { getRoomList } from "@/api/function";
import { getDeviceList } from "@/api/device";
import { getDishList } from "@/api/dish";
export default {
    data() {
        return {
            // 搜索表单
            searchForm: {
                taskNumber: '',
                productName: '', taskName: '',
                status: '',
                workshopId: '',
                operatorId: '',
                createDate: ''
            },

            // 分页参数
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,

            // 生产任务数据
            productionTasks: [], // 原始接口数据（全量/分页）
            filteredTasks: [], // 筛选后的数据
            selectedTasks: [], // 选中的任务（用于批量操作）

            // 关联数据
            productionPlans: [],
            productionWorkshops: [], // 功能间列表
            filteredEquipments: [], // 筛选后的设备列表
            productList: [], // 产品名称下拉框数据源（动态匹配任务类型）

            // 弹窗状态
            taskFormVisible: false,
            assignDialogVisible: false,
            batchAssignDialogVisible: false, // 批量分配弹窗
            detailVisible: false,
            isEditMode: false,

            // 加载状态
            loading: false,

            // 当前操作的任务
            currentTask: null,

            // 任务表单数据
            taskForm: {
                id: '',
                taskName: '',
                taskType: '',
                productName: '',
                productCode: '',
                room: '',
                requiredQuantity: 0,
                orderNo: '',
                productionTime: '',
                createTime: '',
                startTime: '',
                endTime: '',
                pickupTime: '',
                unit: ''
            },

            // 单个分配表单数据
            assignForm: {
                taskId: '',
                taskNumber: '',
                productName: '',
                workshopId: '',
                equipmentId: '',
            },

            // 批量分配表单数据
            batchAssignForm: {
                workshopId: '',
                equipmentId: '',
            },

            // 表单验证规则
            taskFormRules: {
                taskName: [{ required: true, message: '请输入任务名称', trigger: 'blur' }],
                taskType: [{ required: true, message: '请选择任务类型', trigger: 'change' }],
                productName: [{ required: true, message: '请选择产品名称', trigger: 'change' }], // 适配下拉框，change触发验证
                room: [{ required: true, message: '请选择功能间', trigger: 'change' }],
                requiredQuantity: [
                    { required: true, message: '请输入需求数量', trigger: 'blur' },
                    { type: 'number', min: 1, message: '需求数量必须大于0', trigger: 'blur' }
                ],
                unit: [{ required: true, message: '请输入单位', trigger: 'blur' }],
                productionTime: [{ required: true, message: '请选择生产时间', trigger: 'change' }],
                createTime: [{ required: true, message: '请选择创建时间', trigger: 'change' }],

            },

            assignFormRules: {
                workshopId: [{ required: true, message: '请选择功能间', trigger: 'change' }],
                equipmentId: [{ required: true, message: '请选择设备', trigger: 'change' }],
            },

            batchAssignRules: {
                workshopId: [{ required: true, message: '请选择功能间', trigger: 'change' }],
                equipmentId: [{ required: true, message: '请选择设备', trigger: 'change' }],
            }
        };
    },

    computed: {
        // 分页后的数据（基于筛选后的数据做分页切片）
        pagedTasks() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.filteredTasks.slice(start, end);
        }
    },

    mounted() {
        this.fetchProductionTasks();
        this.fetchWorkshops();
        this.getProductList(); // 页面挂载时，默认加载产品列表（默认成品菜）
    },

    methods: {
        // 获取产品列表（用于产品名称下拉框）- 动态匹配任务类型（成品菜/半成品）
        async getProductList() {
            try {
                // 动态获取任务类型（优先取表单选中值，默认成品菜，避免空值导致接口请求异常）
                const taskType = this.taskForm.taskType || '成品菜';
                // 调用菜品接口，获取对应类型的产品列表（与原有getList逻辑一致，适配下拉框）
                const response = await getDishList({ userId: localStorage.getItem('userId'), type: taskType });
                const rawData = response.data || [];
                // 格式化下拉框数据，label和value均为产品名称（适配接口返回字段，可根据实际调整）
                this.productList = rawData.map(item => ({
                    name: item.name || item.dishName, // 适配接口返回的菜品名称字段
                    code: item.code || item.dishCode // 可选：产品编码，如需在表单中使用可自行扩展
                }));
            } catch (error) {
                console.error("获取产品列表失败:", error);
                this.$message.error("获取产品列表失败，请刷新页面");
            }
        },

        // 获取菜品（保留原有逻辑，适配其他功能场景）
        getList() {
            getDishList({ userId: localStorage.getItem('userId'), type: '成品菜' }).then(response => {
                const rawData = response.data || [];
                this.examples = rawData.map(item => ({
                    ...item,
                    price: Number(item.price) || 0,
                    coverImg: item.coverImg,
                }));
            }).catch(error => {
                console.error("获取菜品列表失败:", error);
                this.$message.error("获取菜品列表失败，请刷新页面");
            });
        },

        // 获取功能间列表
        async fetchWorkshops() {
            try {
                const response = await getRoomList({
                    userId: localStorage.getItem('userId')
                });
                this.productionWorkshops = response.data || [];
            } catch (error) {
                console.error('获取功能间列表失败:', error);
                this.$message.error('无法加载功能间数据，请刷新重试');
            }
        },

        // 获取生产任务列表（搜索参数透传+全量/分页数据适配）
        async fetchProductionTasks() {
            this.loading = true;
            try {
                const params = {
                    userId: localStorage.getItem('userId'),
                    // 可根据需求，将搜索表单参数透传至接口，实现后端筛选
                    ...this.searchForm
                };

                const response = await getProductionList(params);

                // 适配接口返回格式（分页/全量）
                if (response.data && response.data.records) {
                    // 接口返回分页数据（{ records: [...], total: number }）
                    this.productionTasks = response.data.records || [];
                    this.totalCount = response.data.total || 0;
                    this.filteredTasks = [...this.productionTasks];
                } else {
                    // 接口返回全量数据，前端处理筛选和分页
                    this.productionTasks = response.data || [];
                    this.totalCount = this.productionTasks.length;
                    this.filterTasks();
                }

            } catch (error) {
                console.error('获取生产任务列表异常:', error);
                this.$message.error('网络异常，无法加载任务数据');
                this.productionTasks = [];
                this.filteredTasks = [];
                this.totalCount = 0;
            } finally {
                this.loading = false;
            }
        },

        // 本地筛选任务（适配全量数据场景）
        filterTasks() {
            if (this.productionTasks.length === 0) {
                this.filteredTasks = [];
                this.totalCount = 0;
                return;
            }

            let filtered = [...this.productionTasks];

            // 1. 任务编号筛选（模糊匹配，不区分大小写）
            if (this.searchForm.taskNumber) {
                const keyword = this.searchForm.taskNumber.trim().toLowerCase();
                filtered = filtered.filter(task =>
                    task.taskNumber?.toLowerCase().includes(keyword)
                );
            }

            // 2. 产品名称筛选（模糊匹配，不区分大小写）
            if (this.searchForm.taskName) {
                const keyword = this.searchForm.taskName.trim().toLowerCase();
                filtered = filtered.filter(task =>
                    task.taskName?.toLowerCase().includes(keyword)
                );
            }

            // 3. 任务状态筛选
            if (this.searchForm.status) {
                filtered = filtered.filter(task =>
                    task.taskStatus === this.searchForm.status
                );
            }

            // 4. 功能间筛选（通过workshopId匹配room名称）
            if (this.searchForm.workshopId) {
                const targetRoom = this.productionWorkshops.find(w => w.id === this.searchForm.workshopId)?.roomName;
                if (targetRoom) {
                    filtered = filtered.filter(task =>
                        task.room === targetRoom
                    );
                } else {
                    filtered = []; // 无匹配的功能间，返回空
                }
            }

            this.filteredTasks = filtered;
            this.totalCount = filtered.length;
        },

        // 显示创建任务弹窗
        showAddTaskDialog() {
            this.isEditMode = false;
            this.taskFormVisible = true;

            const now = new Date();
            const tomorrow = new Date(now.getTime() + 86400000);

            // 重置表单，默认时间赋值
            this.taskForm = {
                id: '',
                taskName: '',
                taskType: '',
                productName: '',
                productCode: '',
                room: '',
                requiredQuantity: 0,
                orderNo: '',
                productionTime: this.formatDate(now),
                createTime: this.formatDate(now),
                startTime: this.formatDate(now),
                endTime: this.formatDate(tomorrow),
                pickupTime: '',
                unit: ''
            };
            // 重置任务类型后，重新加载产品列表（默认成品菜）
            this.getProductList();
        },

        // 日期格式化工具（统一时间格式，适配接口和页面显示）
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hour = String(date.getHours()).padStart(2, '0');
            const minute = String(date.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day} ${hour}:${minute}:00`;
        },

        // 保存任务（任务类型选中什么传什么，产品名称取下拉框选中值）
        async saveTask() {
            this.$refs.taskForm.validate(async (valid) => {
                if (valid) {
                    try {
                        const params = {
                            unit: this.taskForm.unit,
                            taskName: this.taskForm.taskName,
                            taskType: this.taskForm.taskType, // 关键：直接传选中的任务类型（成品菜/半成品）
                            productName: this.taskForm.productName, // 下拉框选中的产品名称
                            productCode: this.taskForm.productCode,
                            room: this.taskForm.room,
                            requiredQuantity: this.taskForm.requiredQuantity,
                            orderNo: this.taskForm.orderNo,
                            productionTime: this.taskForm.productionTime,
                            createTime: this.taskForm.createTime,
                            startTime: '',
                            endTime: '',
                            pickupTime: this.taskForm.pickupTime,
                            userId: localStorage.getItem('userId'),
                            taskStatus: '0',
                            progress: 0
                        };

                        const response = await addProduction(params);
                        this.$message.success(response.message);
                        this.taskFormVisible = false;
                        this.fetchProductionTasks(); // 保存成功后，重新获取任务列表

                    } catch (error) {
                        console.error('新增任务失败:', error);
                        this.$message.error('网络异常，创建任务失败');
                    }
                }
            });
        },

        // 单个任务分配
        assignTask(task) {
            this.assignForm = {
                taskId: task.id,
                taskNumber: task.taskNumber,
                productName: task.productName,
                workshopId: task.workshopId || '',
                equipmentId: task.equipmentId || '',
            };
            // 切换功能间时，加载对应设备
            if (this.assignForm.workshopId) {
                this.handleWorkshopChange(this.assignForm.workshopId);
            } else {
                this.filteredEquipments = [];
            }
            this.assignDialogVisible = true;
        },

        // 功能间变更时，查询对应设备（适配单个/批量分配）
        async handleWorkshopChange(workshopId) {
            const targetWorkshopId = workshopId || this.assignForm.workshopId || this.batchAssignForm.workshopId;

            if (targetWorkshopId) {
                this.loading = true;
                try {
                    const params = {
                        userId: localStorage.getItem('userId'),
                        deviceType: '工位屏',
                        roomId: targetWorkshopId
                    };
                    const response = await getDeviceList(params);
                    this.filteredEquipments = response.data || [];
                    if (this.filteredEquipments.length === 0) {
                        this.$message.warning('该功能间暂无可用设备');
                    }
                } catch (error) {
                    console.error('获取设备列表失败:', error);
                    this.$message.error('无法加载设备数据，请刷新重试');
                    this.filteredEquipments = [];
                } finally {
                    this.loading = false;
                }
            } else {
                this.filteredEquipments = [];
                this.assignForm.equipmentId = '';
                this.batchAssignForm.equipmentId = '';
            }
        },

        // 确认单个分配
        async confirmAssign() {
            this.$refs.assignForm.validate(async (valid) => {
                if (valid) {
                    try {
                        const workshop = this.productionWorkshops.find(w => w.id === this.assignForm.workshopId);
                        const equipment = this.filteredEquipments.find(eq => eq.deviceSerialnumber === this.assignForm.equipmentId);

                        if (!workshop || !equipment) {
                            this.$message.error('分配信息不完整，请检查');
                            return;
                        }

                        // 调用分配接口
                        const response = await updateProductionStatus({
                            ids: [this.assignForm.taskId],
                            deviceSerialnumber: this.assignForm.equipmentId,
                            userId: localStorage.getItem('userId')
                        });

                        // 更新本地数据，实时显示分配结果
                        const taskIndex = this.productionTasks.findIndex(t => t.id === this.assignForm.taskId);
                        if (taskIndex !== -1) {
                            this.productionTasks[taskIndex] = {
                                ...this.productionTasks[taskIndex],
                                taskStatus: '1',
                                workshopId: workshop.id,
                                room: workshop.roomName,
                                equipmentId: equipment.deviceSerialnumber,
                                equipmentName: equipment.deviceName,
                                assignTime: this.formatDate(new Date()),
                                progress: 30,
                            };
                        }

                        this.filterTasks(); // 重新筛选，更新列表
                        this.assignDialogVisible = false;
                        this.$message.success(response.message);

                    } catch (error) {
                        console.error('任务分配异常:', error);
                        this.$message.error('网络异常，分配失败');
                    }
                }
            });
        },

        // 打开批量分配弹窗（校验选中任务数量）
        openBatchAssignDialog() {
            if (this.selectedTasks.length === 0) {
                this.$message.warning('请选择至少一条任务');
                return;
            }
            this.batchAssignDialogVisible = true;
            this.batchAssignForm = { workshopId: '', equipmentId: '' };
            this.filteredEquipments = [];
        },

        // 提交批量分配
        async submitBatchAssign() {
            this.$refs.batchAssignForm.validate(async (valid) => {
                if (!valid) return;

                try {
                    const workshop = this.productionWorkshops.find(w => w.id === this.batchAssignForm.workshopId);
                    const equipment = this.filteredEquipments.find(eq => eq.deviceSerialnumber === this.batchAssignForm.equipmentId);

                    if (!workshop || !equipment) {
                        this.$message.error('分配信息不完整，请检查');
                        return;
                    }

                    // 调用批量分配接口
                    const params = {
                        ids: this.selectedTasks.map(task => task.id),
                        deviceSerialnumber: this.batchAssignForm.equipmentId,
                        userId: localStorage.getItem('userId')
                    };

                    const response = await updateProductionStatus(params);

                    // 批量更新本地数据
                    this.selectedTasks.forEach(selectedTask => {
                        const taskIndex = this.productionTasks.findIndex(t => t.id === selectedTask.id);
                        if (taskIndex !== -1) {
                            this.productionTasks[taskIndex] = {
                                ...this.productionTasks[taskIndex],
                                taskStatus: '1',
                                workshopId: workshop.id,
                                room: workshop.roomName,
                                equipmentId: equipment.deviceSerialnumber,
                                equipmentName: equipment.deviceName,
                                assignTime: this.formatDate(new Date()),
                                progress: 30,
                            };
                        }
                    });

                    this.filterTasks(); // 重新筛选，更新列表
                    this.batchAssignDialogVisible = false;
                    this.selectedTasks = []; // 清空选中任务
                    this.$message.success(response.message);

                } catch (error) {
                    console.error('批量分配异常:', error);
                    this.$message.error('网络异常，批量分配失败');
                }
            });
        },

        // 查看任务详情（深拷贝，避免修改原数据）
        viewTaskDetail(task) {
            this.currentTask = { ...task };
            this.detailVisible = true;
        },

        // 搜索任务（重置页码，重新请求接口/筛选）
        handleSearch() {
            this.currentPage = 1;
            this.fetchProductionTasks(); // 优先调用接口筛选，适配后端分页
        },

        // 重置搜索表单（清空参数，重新加载列表）
        resetSearch() {
            this.searchForm = {
                taskNumber: '',
                productName: '',
                status: '',
                workshopId: '',
                operatorId: '',
                createDate: ''
            };
            this.currentPage = 1;
            this.fetchProductionTasks();
        },

        // 导出任务清单（模拟导出，可根据实际接口调整）
        exportTaskList() {
            this.$message.info('正在导出任务清单...');
            setTimeout(() => {
                this.$message.success('任务清单导出成功');
            }, 1000);
        },

        // 获取状态标签样式（适配不同状态显示）
        getStatusType(taskStatus) {
            const typeMap = {
                '0': 'info',
                '1': 'processing',
                '2': 'success',
                'rejected': 'danger'
            };
            return typeMap[taskStatus] || 'default';
        },

        // 格式化状态文本（将状态值转为中文显示）
        formatStatus(taskStatus) {
            const statusMap = {
                '0': '未开始',
                '1': '进行中',
                '2': '已结束',
                'rejected': '已驳回'
            };
            return statusMap[taskStatus] || '未知状态';
        },

        // 处理表格多选（同步选中任务列表）
        handleSelectionChange(selection) {
            this.selectedTasks = selection;
        },

        // 分页大小改变（重置页码，重新加载）
        handleSizeChange(size) {
            this.pageSize = size;
            this.currentPage = 1;
            this.fetchProductionTasks();
        },

        // 当前页改变（重新加载对应页码数据）
        handleCurrentChange(page) {
            this.currentPage = page;
            this.fetchProductionTasks();
        }
    }
};
</script>

<style lang="scss" scoped>
.production-task {
    padding: 20px;
    min-height: 100vh;
}

.search-card {
    margin-bottom: 20px;

    .search-form {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        padding: 10px 0;
    }
}

.task-list-card {
    .el-table {
        margin-bottom: 15px;
    }
}

.pagination-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 15px;
    padding: 10px 0;
}

.task-form {
    padding: 10px 0;
}

.task-detail {
    padding: 10px 0;

    .detail-section {
        margin-top: 20px;

        h3 {
            font-size: 16px;
            margin-bottom: 10px;
            color: #1f2329;
            font-weight: 500;
        }

        .detail-content {
            padding: 10px;
            background-color: #f9fafb;
            border-radius: 4px;
            line-height: 1.6;
        }
    }
}

// 时间线样式调整
::v-deep .el-timeline {
    padding-left: 20px;
    margin-top: 10px;
}

::v-deep .el-timeline-item__timestamp {
    font-size: 12px;
    color: #666;
}

.timeline-content {
    .record-operator {
        font-weight: 500;
        margin-bottom: 5px;
    }

    .record-action {
        margin-bottom: 5px;
    }

    .record-remark {
        font-size: 13px;
        color: #666;
        padding: 5px 10px;
        background-color: #f5f5f5;
        border-radius: 3px;
    }
}

// 详情表单样式调整
::v-deep .el-descriptions__item {
    padding: 12px 16px;
}

::v-deep .el-descriptions__label {
    font-weight: 500;
}
</style>